import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { ToastModule } from '@libs/src/toast/toast.module';
import { ProfileHubItemModule } from '@main-client/src/app/profile/profile-hub-item/profile-hub-item.module';

import { ProfileHubSettingsDialogService } from '@main-client/src/app/profile/profile-hub-settings-dialog/profile-hub-settings-dialog.service';

import { ProfileHubSettingsDialogComponent } from '@main-client/src/app/profile/profile-hub-settings-dialog/profile-hub-settings-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatButtonModule,
    MatDialogModule,
    ProfileHubItemModule,
    RouterModule.forChild([]),
    ToastModule,
  ],
  declarations: [ProfileHubSettingsDialogComponent],
  exports: [ProfileHubSettingsDialogComponent],
  providers: [ProfileHubSettingsDialogService],
})
export class ProfileHubSettingsDialogModule {}
